import { Theme } from "@material-ui/core";
import { createStyles } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

export const UploadPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      textAlign: "center",
    },
    content: {
      flex: "1 0 auto",
    },
    resetButton: {
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(5),
    },
  })
);
